module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    attrs: {
      "to": "/organizations",
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-users"
  }), _c('span', [_vm._v("Kerjasama")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7727eb1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/organizations/Navigation.vue
// module id = 1370
// module chunks = 0